/**
 * Takeaway Module Constants
 * Centralized configuration and constant values
 */

// Order types
export const ORDER_TYPES = {
  DINE_IN: "dinein",
  TAKEAWAY: "takeaway",
};

// Form validation
export const VALIDATION = {
  MIN_SEARCH_LENGTH: 2,
  MAX_PHONE_LENGTH: 10,
  MIN_PRODUCTS: 1,
};

// Toast configuration
export const TOAST_CONFIG = {
  position: "top-center",
  autoClose: 3000,
};

// Initial customer state
export const INITIAL_CUSTOMER_STATE = {
  name: "",
  phone: "",
  address: "",
  orderType: ORDER_TYPES.TAKEAWAY,
};

// API endpoints
export const API_ENDPOINTS = {
  SEARCH_PRODUCTS: "/products/search",
  CREATE_ORDER: "/orders/create-and-accept",
};

// UI messages
export const MESSAGES = {
  PRODUCT_ADDED: (name) => `${name} added to order!`,
  QUANTITY_INCREASED: (name) => `${name} quantity increased!`,
  PRODUCT_REMOVED: "Product removed from order",
  ORDER_CLEARED: "Order cleared",
  ORDER_SUCCESS: "Order created successfully!",
  ORDER_FAILED: "Failed to create order",

  // Validation messages
  NO_PRODUCTS: "Add at least 1 product to the order",
  INVALID_QUANTITY: "Product quantity cannot be 0",
  NAME_REQUIRED: "Customer name is required",
  PHONE_REQUIRED: "Phone number is required",
};
